module.exports = __webpack_public_path__ + "static/media/วอก.d6dc4f65.jpg";